import React from 'react';
import PropTypes from 'prop-types';

import AccountCardAddresses from './AccountCardAddresses';
import withModal from '../../../../../../components/global/modal/withModal';

export const ACCOUNT_CARD_ADDRESSES_MODAL = 'modal/ACCOUNT_CARD_ADDRESSES';

const propTypes = {
  accountCard: PropTypes.shape({
    id: PropTypes.string,
  }),
  actionProps: PropTypes.shape({
    accountCard: PropTypes.shape({
      id: PropTypes.string,
    }),
  }),
};

const AccountCardAddressesModal = ({ actionProps, accountCard, ...props }) => {
  const { accountCard: actionPropsAccountCard } = actionProps ?? {};

  return (
    <AccountCardAddresses
      accountCard={accountCard ?? actionPropsAccountCard}
      {...props}
    />
  );
};

AccountCardAddressesModal.propTypes = propTypes;

export default withModal(AccountCardAddressesModal, {
  name: ACCOUNT_CARD_ADDRESSES_MODAL,
  size: 'sm',
  type: 'full',
});
